import * as React from 'react';

import { cn } from '@/lib/utils';

export type PublicHeroBackgroundProps = {
  className?: string;
};

/**
 * Gradient + animated orb backdrop used across the public/marketing page
 * heroes. Lives as its own primitive so heroes that need a custom
 * foreground layout (e.g. the two-column resume-builder landing) can share
 * the same atmospheric treatment without duplicating the orb stack.
 */
export function PublicHeroBackground({ className }: PublicHeroBackgroundProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'absolute inset-0 overflow-hidden pointer-events-none',
        className,
      )}
    >
      <div className="absolute -inset-4 bg-gradient-to-br from-background via-primary/2 to-secondary/3" />
      <div className="absolute -top-40 -right-40 h-80 w-80 rounded-full bg-gradient-to-br from-primary/20 to-secondary/20 blur-3xl animate-pulse" />
      <div className="absolute top-1/3 -left-20 h-60 w-60 rounded-full bg-gradient-to-tr from-accent/15 to-primary/15 blur-2xl" />
      <div className="absolute bottom-20 right-1/4 h-40 w-40 rounded-full bg-gradient-to-bl from-secondary/25 to-accent/20 blur-xl animate-pulse" />
      <div className="absolute top-1/2 left-1/2 h-[400px] w-full -translate-x-1/2 -translate-y-1/2 rounded-full bg-gradient-to-r from-primary/3 via-secondary/5 to-accent/3 blur-3xl" />
    </div>
  );
}
